export default {
  // Navbar
  'nav.features': '功能',
  'nav.technology': '技术',
  'nav.useCases': '使用案例',
  'nav.demo': '演示',
  'nav.contact': '联系我们',
  'nav.docs': '文档',

  // Hero
  'hero.title': 'Your Age, Verified.',
  'hero.title2': 'Your Identity, Protected.',
  'hero.subtitle': 'ZK Face是一种基于零知识的认证技术，可以在不暴露面部的情况下验证"19岁以上"。',
  'hero.cta.demo': 'Try Full Demo',
  'hero.cta.contact': 'Contact Partnership',
  'hero.ageGuess.title': '我看起来几岁？',
  'hero.ageGuess.upload': '上传照片',
  'hero.ageGuess.badge': '照片不会发送到服务器',
  'hero.ageGuess.result': 'AI估计年龄',
  'hero.ageGuess.confidence': '置信区间',
  'hero.ageGuess.privacy1': 'No Storage',
  'hero.ageGuess.privacy2': '100% Local ML',
  'hero.ageGuess.privacy3': 'No Identity Exposure',

  // Problem
  'problem.title': 'The Internet Keeps Asking for Your Identity.',
  'problem.title2': 'But Why Should You Give It Away?',
  'problem.description': '大多数在线服务仍然要求提供高风险的个人信息，如社会保障号码、原始面部图像和出生日期。用户感到焦虑，服务提供商承担过度责任。',
  'problem.point1.title': '个人数据泄露风险',
  'problem.point1.desc': '存储在中央服务器上的敏感信息始终面临黑客攻击的风险。',
  'problem.point2.title': '中央服务器存储',
  'problem.point2.desc': '面部和身份信息永久存储在第三方服务器上。',
  'problem.point3.title': '全球监管加强',
  'problem.point3.desc': 'GDPR、CCPA等隐私法规越来越严格。',
  'problem.point4.title': 'Web3效率低下',
  'problem.point4.desc': '传统KYC系统不适合去中心化环境。',

  // Solution
  'solution.title': 'Prove Your Age. Reveal Nothing.',
  'solution.description': 'ZK Face基于三个核心原则运作。',
  'solution.card1.title': 'Zero-Knowledge Proof',
  'solution.card1.desc': '证明年龄而不透露身份信息。',
  'solution.card2.title': 'Local Machine Learning',
  'solution.card2.desc': '所有面部分析仅在用户设备上执行。',
  'solution.card3.title': 'Data-Free Certification',
  'solution.card3.desc': '服务器不存储任何照片，仅验证证明。',

  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.subtitle': '整个过程的设计确保服务器和面部信息永不交叉。',
  'howItWorks.step1.title': '捕获面部',
  'howItWorks.step1.desc': '图像在用户的本地设备上准备。',
  'howItWorks.step2.title': 'ML模型分析特征',
  'howItWorks.step2.desc': '仅生成特征值而不存储面部。',
  'howItWorks.step3.title': '生成ZK-Proof',
  'howItWorks.step3.desc': '仅在设备内部提取"此用户超过19岁"的证明。',
  'howItWorks.step4.title': '服务器验证',
  'howItWorks.step4.desc': '仅传输证明，原始信息不会发送到服务器。',

  // Use Cases
  'useCases.title': 'Use Cases',
  'useCases.subtitle': 'ZK Face可以在各个行业中使用。',
  'useCases.case1.title': 'Adult Verification for Web/Apps',
  'useCases.case1.desc': '在网站和应用程序上安全处理成人验证。',
  'useCases.case2.title': 'Web3 Wallet Login + Age Gate',
  'useCases.case2.desc': '与去中心化钱包集成的年龄验证系统。',
  'useCases.case3.title': 'Streaming·Gaming Age Control',
  'useCases.case3.desc': '流媒体和游戏平台的年龄限制功能。',
  'useCases.case4.title': 'Offline Kiosk Verification',
  'useCases.case4.desc': '即使在离线自助服务终端上也可以进行安全认证。',
  'useCases.case5.title': 'Government Light-KYC Services',
  'useCases.case5.desc': '政府服务的轻量级身份验证解决方案。',
  'useCases.badge1': 'No Face Storage',
  'useCases.badge2': 'ZKP Verified',

  // Contact
  'contact.title': "Let's Build a Privacy-First Future Together.",
  'contact.subtitle': '如果您有任何合作咨询或技术问题，请随时与我们联系。',
  'contact.form.name': '姓名',
  'contact.form.email': '电子邮件',
  'contact.form.company': '公司',
  'contact.form.message': '消息',
  'contact.form.submit': '发送消息',
  'contact.form.submitting': '发送中...',
  'contact.form.success': '您的消息已成功发送！',
  'contact.form.error': '发送时发生错误。请重试。',
  'contact.cta.contact': 'Contact Us',
  'contact.cta.deck': 'Download Partnership Deck',

  // Footer
  'footer.description': '通过基于零知识的面部认证技术保护隐私。',
  'footer.product': '产品',
  'footer.product.features': '功能',
  'footer.product.technology': '技术',
  'footer.product.useCases': '使用案例',
  'footer.product.demo': '演示',
  'footer.resources': '资源',
  'footer.resources.docs': '文档',
  'footer.resources.api': 'API',
  'footer.resources.sdk': 'SDK',
  'footer.resources.blog': '博客',
  'footer.company': '公司',
  'footer.company.about': '关于我们',
  'footer.company.careers': '招聘',
  'footer.company.press': 'Press Kit',
  'footer.company.contact': '联系我们',
  'footer.legal': '法律',
  'footer.legal.privacy': '隐私政策',
  'footer.legal.terms': '服务条款',
  'footer.legal.security': '安全',
  'footer.copyright': '© 2025 ZK Face. All rights reserved.',
  'footer.poweredBy': 'Website Builder',
};
